'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeResourceInvalidatedActionCreator = exports.makeResourceStaleActionCreator = exports.makeResourceErrorActionCreator = exports.makeResourceActionCreator = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resourceConstants = require('./resourceConstants');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var makeResourceActionCreator = function makeResourceActionCreator(resourceType, actionType) {
    return function (_ref) {
        var id = _ref.id,
            ids = _ref.ids,
            rest = _objectWithoutProperties(_ref, ['id', 'ids']);

        return _extends({
            type: actionType,
            resource: resourceType,
            ids: id ? [id] : ids
        }, rest);
    };
};

exports.makeResourceActionCreator = makeResourceActionCreator;
var makeResourceErrorActionCreator = exports.makeResourceErrorActionCreator = function makeResourceErrorActionCreator(resourceType) {
    return makeResourceActionCreator(resourceType, _resourceConstants.RESOURCES_FETCH_ERROR);
};

var makeResourceStaleActionCreator = exports.makeResourceStaleActionCreator = function makeResourceStaleActionCreator(resourceType) {
    return makeResourceActionCreator(resourceType, _resourceConstants.RESOURCES_MARKED_AS_STALE);
};

var makeResourceInvalidatedActionCreator = exports.makeResourceInvalidatedActionCreator = function makeResourceInvalidatedActionCreator(resourceType) {
    return function () {
        return {
            type: _resourceConstants.RESOURCES_INVALIDATED,
            resource: resourceType
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/resourceActions.js
// module id = 765
// module chunks = 0